/**
 * Parse a leasing.ai tracking snippet, loader URL, pixel URL, or bare pid.
 *
 * Vendor snippet:
 *   <script async src="https://cdn.leasing.ai/prod/v1/loader.js?pid=..."></script>
 *   <img src="https://api.leasing.ai/v1/widgets/pixel/..." width="1" height="1" ... />
 */

const PID_PARAM_PATTERN = /[?&]pid=([a-f0-9]+)/i;
const PIXEL_PATH_PATTERN = /\/v1\/widgets\/pixel\/([a-f0-9]+)/i;
const SNIPPET_PATTERN = /<script[\s>]|<img[\s>]|leasing\.ai|https?:\/\//i;
const PID_PATTERN = /^[a-f0-9]{16,}$/i;

export function buildLoaderSrc(pid: string): string {
  return `https://cdn.leasing.ai/prod/v1/loader.js?pid=${pid}`;
}

export function buildPixelSrc(pid: string): string {
  return `https://api.leasing.ai/v1/widgets/pixel/${pid}`;
}

function normalizeValue(value: string | null | undefined): string | null {
  if (!value) return null;
  const trimmed = value.trim();
  return trimmed || null;
}

/**
 * Accept the full vendor snippet, either URL, or a bare pid. Snippets and
 * URLs without a pid are rejected rather than treated as a pid.
 */
export function extractLeasingAiPid(value: string | null | undefined): string | null {
  const normalized = normalizeValue(value);
  if (!normalized) return null;

  const fromParam = normalizeValue(normalized.match(PID_PARAM_PATTERN)?.[1]);
  if (fromParam) return fromParam.toLowerCase();

  const fromPath = normalizeValue(normalized.match(PIXEL_PATH_PATTERN)?.[1]);
  if (fromPath) return fromPath.toLowerCase();

  if (SNIPPET_PATTERN.test(normalized)) return null;
  return PID_PATTERN.test(normalized) ? normalized.toLowerCase() : null;
}
